export default __webpack_public_path__ + "static/media/biofit-builder-series-EE.5b0f3221.png";